module.exports = __webpack_public_path__ + "img/soundSport.f681a545.png";